export default class FocusManager {
  constructor(target, attr) {
    this._target = target || document.body;
    this._attr = attr || 'data-focus-method';
    this._focusMethod = null;
    this._lastFocusMethod = null;
    this._onKeyDown = this._onKeyDown.bind(this);
    this._onMouseDown = this._onMouseDown.bind(this);
    this._onTouchStart = this._onTouchStart.bind(this);
    this._onFocus = this._onFocus.bind(this);
    this._onBlur = this._onBlur.bind(this);
    this._onWindowBlur = this._onWindowBlur.bind(this);
    this._bindEvents();
  }

  _bindEvents() {
    if (this._target.addEventListener) {
      this._target.addEventListener('keydown', this._onKeyDown, true);
      this._target.addEventListener('mousedown', this._onMouseDown, true);
      this._target.addEventListener('touchstart', this._onTouchStart, true);
      this._target.addEventListener('focus', this._onFocus, true);
      this._target.addEventListener('blur', this._onBlur, true);
      window.addEventListener('blur', this._onWindowBlur);
    }
  }

  _unbindEvents() {
    if (this._target.removeEventListener) {
      this._target.removeEventListener('keydown', this._onKeyDown, true);
      this._target.removeEventListener('mousedown', this._onMouseDown, true);
      this._target.removeEventListener('touchstart', this._onTouchStart, true);
      this._target.removeEventListener('focus', this._onFocus, true);
      this._target.removeEventListener('blur', this._onBlur, true);
      window.removeEventListener('blur', this._onWindowBlur);
    }
  }

  _onKeyDown() {
    this._focusMethod = 'key';
  }

  _onMouseDown() {
    if (this._focusMethod !== 'touch') {
      this._focusMethod = 'mouse';
    }
  }

  _onTouchStart() {
    this._focusMethod = 'touch';
  }

  _onFocus(event) {
    if (!this._focusMethod) {
      this._focusMethod = this._lastFocusMethod;
    }

    event.target.setAttribute(this._attr, this._focusMethod);
    this._lastFocusMethod = this._focusMethod;
    this._focusMethod = null;
  }

  _onBlur(event) {
    event.target.removeAttribute(this._attr);
  }

  _onWindowBlur() {
    this._focusMethod = null;
  }

  destroy() {
    this._unbindEvents();
  }
}

export { default as runFocusManager } from './runner';
